import { extractFileUrlFromOfficeSharePointLink } from './extractFileUrlFromOfficeSharePointLink';
import { isLinkPrefixedWithBaseUrl } from './isLinkPrefixedWithBaseUrl';
import isSharePointLink from './isSharePointLink';

const OFFICE_LINK_BASE_URLS = [
    'https://www.office.com',
    'https://www.officeppe.com',
    'https://www.ohome.apps.mil',
    'https://www.office365.us',
    'https://www.office.de',
];

export function isOfficeSharePointLink(url: string): boolean {
    if (!OFFICE_LINK_BASE_URLS.some(baseUrl => isLinkPrefixedWithBaseUrl(url, baseUrl))) {
        return false;
    }

    const fileUrl: string | null = extractFileUrlFromOfficeSharePointLink(url);
    return isSharePointLink(fileUrl);
}
